import { FeatureFlags } from '@constants/featureFlags';
import { createAppStore } from '@store/createAppStore';
import { createFeatureFlagUtils } from '@utils/createFeatureFlagUtils';

import { GetFeatureFlags } from './service';
import {
  Feature,
  FeatureFlagExplorerState,
  FeatureFlagManagerState,
  FeatureFlagState,
} from './types';

const [featureFlagStore, setFeatureFlagStore] =
  createAppStore<FeatureFlagState>(
    {
      isLoading: false,
      isError: false,
      loaded: false,
      errorMessage: undefined,
      flags: [] as Feature[],
    },
    'featureFlagStore',
  );

const [featureFlagExplorerStore, setFeatureFlagExplorerStore] =
  createAppStore<FeatureFlagExplorerState>(
    {
      isLoading: false,
      featureFlagsForOffice: [],
    },
    'featureFlagExplorerStore',
  );

const [featureFlagManagerStore, setFeatureFlagManagerStore] =
  createAppStore<FeatureFlagManagerState>(
    {
      isLoading: false,
      isError: false,
      loaded: false,
      errorMessage: undefined,
      templates: [],
      templateFeatures: [],
      featureFlags: [],
      overrides: [],
    },
    'featureFlagManagerStore',
  );

const { initializeFeatureFlags, isFeatureFlagEnabled } = createFeatureFlagUtils(
  setFeatureFlagStore,
  GetFeatureFlags,
  () => featureFlagStore.flags,
);

const isPortRemainingV3ApisEnabled = isFeatureFlagEnabled(
  FeatureFlags.PortRemainingV3Apis,
);

export {
  featureFlagExplorerStore,
  featureFlagManagerStore,
  featureFlagStore,
  initializeFeatureFlags,
  isFeatureFlagEnabled,
  isPortRemainingV3ApisEnabled,
  setFeatureFlagExplorerStore,
  setFeatureFlagManagerStore,
};
